const EXTRAMILE_GUEST_JOIN = process.env.REACT_APP_EXTRAMILE_GUEST_JOIN_URL || "";
const EXTRAMILE_SIGNUP = process.env.REACT_APP_EXTRAMILE_SIGNUP_URL || "";

export function buildExtramileJoinUrl(isGuest, gameId, sessionId, organizationId) {
  const rawBase = isGuest ? EXTRAMILE_GUEST_JOIN : EXTRAMILE_SIGNUP;
  const base = String(rawBase || "").replace(/\/$/, "");
  if (!base) return "";
  const u = new URL(base);
  u.searchParams.set("gameId", String(gameId ?? ""));
  u.searchParams.set("sessionId", String(sessionId ?? ""));
  u.searchParams.set("organizationId", String(organizationId ?? ""));
  return u.toString();
}

export function appendLobbyShareFlagsToJoinUrl(baseUrl, lobbyId) {
  const base = String(baseUrl ?? "").trim();
  const id = String(lobbyId ?? "").trim();
  if (!base) return "";
  if (!id) return base;
  try {
    const u = new URL(base);
    u.searchParams.set("lobby", id);
    return u.toString();
  } catch {
    return base;
  }
}

export function deriveGuestFromUser(u) {
  const raw = String(u?.user_type ?? u?.userType ?? u?.role ?? u?.source ?? "").trim();
  const ut = raw.toUpperCase().replace(/\s+/g, "_").replace(/-+/g, "_");
  if (ut === "ORG_USER" || ut === "ORG" || ut === "ORGUSER" || ut.startsWith("ORG_")) return false;
  if (ut === "GUEST_USER" || ut === "GUEST" || ut.startsWith("GUEST_")) return true;
  return true;
}

export function buildFallbackAppLink(lobbyName) {
  const base = String(process.env.REACT_APP_BASE_URL || window.location.origin || "").replace(/\/+$/, "");
  const l = encodeURIComponent(String(lobbyName || ""));
  if (!base) return "";
  if (!l) return `${base}/login`;
  return `${base}/login?lobby=${l}`;
}

export function withQuestionAmp(url) {
  const s = String(url || "");
  return s.includes("?") ? s.replace("?", "?&") : s;
}
